const soap = {
    "92":"Așa utilizator nu există",
    "10":"Nu este indicat corect loginul sau parola",
    "142":"Nu este indicat numele",
    "141":"Nu este indicată parola",
    "140":"Nu este indicată adresa poștei electronice",
    "96":"Utilizator cu așa adresă a poștei electronice deja există!",
    "411":"nu a reușit Autorizarea-Eroare necunoscută",
    "419":"nu a reușit Autorizarea-eroare de sistem. Nu există setări",
    "421":"nu a reușit Autorizarea- nu este codul de autorizare",
    "423":"nu a reușit Autorizarea-nu am reușit să obțin simbolul",
    "424":"nu a reușit Autorizarea-nu a putut obține informații despre utilizator",
    "425":"nu a reușit Autorizarea-nu a finalizat solicitarea utilizatorului",
    "426":"Crearea utilizatorului nu a reușit-un astfel de nume de utilizator sau adresă de e-mail există deja",
    "427":"Crearea utilizatorului nu a reușit- Această adresă de email este deja înregistrată",
    "428":"Crearea utilizatorului nu a reușit-acest număr de telefon este deja înregistrat",
    "430":"Eroare tehnică - nu se poate obține ID-ul sesiunii. Încercați să vă autentificați",
    "611":"Tranzacția a fost respinsă - Verificați detaliile cardului sau contactați banca dvs.",
    "612":"Tranzacție respinsă",
    "613":"Tranzacția a respinsă - fonduri insuficiente",
    "615":"Tranzacția a fost respinsă - Eroare 3D Secure. Vă rugăm să contactați banca dvs.",
    "411":"Așa utilizator nu există. <a href='{link}'>Rugăm să Vă înregistrați</a>.",
    "712":"Rugăm să completați cîmpul ”Scop”",
    "713":"Rugăm să completați cîmpul ”Nume”",
    "714":"Adresa de e-mail trebuie completată",
    "715":"Cîmpul de telefon trebuie completat",
    "716":"Vă rugăm să indicați numele părintelui",
    "717":"Vă rugăm să indicați vîrsta",
    "916":"Actualizarea profilului nu a reușit - aceeași adresă de e-mail există deja",
    "918":"Conectarea profilului nu a reușit. Poate că acest profil este deja legat de un alt utilizator, vă rugăm să contactați asistența"
};
export default soap